var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 178,
    viewBox: "0 0 134 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_18)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.80664 22.4474C5.80664 10.2391 15.7323 0.313477 27.9405 0.313477H105.409C117.617 0.313477 127.543 10.2391 127.543 22.4474V155.251C127.543 167.459 117.617 177.385 105.409 177.385H27.9405C15.7323 177.385 5.80664 167.459 5.80664 155.251V22.4474ZM77.7418 155.251C77.7418 152.316 76.5758 149.501 74.5004 147.425C72.4249 145.35 69.61 144.184 66.6749 144.184C63.7397 144.184 60.9248 145.35 58.8494 147.425C56.7739 149.501 55.6079 152.316 55.6079 155.251C55.6079 158.186 56.7739 161.001 58.8494 163.076C60.9248 165.152 63.7397 166.318 66.6749 166.318C69.61 166.318 72.4249 165.152 74.5004 163.076C76.5758 161.001 77.7418 158.186 77.7418 155.251ZM105.409 22.4474H27.9405V133.117H105.409V22.4474Z",
    fill: "#45BE8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9395 22.4473H105.408V133.117H27.9395V22.4473Z",
    fill: "#34AD7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.803,
    height: 177.071,
    fill: "white",
    transform: "translate(0.273438 0.313477)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.fbd0ef9aff30253905699c8c7b70e678.svg";
export { ForwardRef as ReactComponent };